// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__Tqg5V","footer":"ReportModalFilter_footer__3JAyO"};